import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { BreakableText } from "@design-system/BreakableText/BreakableText";
import { HStack } from "@design-system/HStack/HStack";
import { Tag } from "@design-system/Tag/Tag";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { ReportTemplateRow } from "../reportTemplatesViewConfig";

const FIRM_DEFAULT_TOOLTIP =
    "Used for every client and entity without its own template.";

export const ReportTemplateNameCell = memo(
    ({ row }: CellContext<ViewTableFeatures, ReportTemplateRow, string>) => (
        <ViewTableCell>
            <HStack as="span" align="center" gap={8}>
                <BreakableText showTooltip text={row.original.name} />
                {row.original.isDefault && (
                    <Tooltip content={FIRM_DEFAULT_TOOLTIP}>
                        <span>
                            <Tag color="neutral" size="sm" outline>
                                Firm default
                            </Tag>
                        </span>
                    </Tooltip>
                )}
                {row.original.isArchived && (
                    <Tag color="neutral" size="sm">
                        Archived
                    </Tag>
                )}
            </HStack>
        </ViewTableCell>
    ),
);
